import {
  db,
} from "../../../firebase/config";

import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  orderBy,
} from "firebase/firestore";

export const listenToRepliesFromFirestore = (
  projectId
) => {
  return query(
    collection(db, "replies"),
    where(
      "projectId",
      "==",
      projectId
    ),
    orderBy("createdAt", "desc")
  );
};

export const addReplyToFirestore = async ({
  reply,
  projectId,
  createdBy,
  attachments = [],
}) => {
  return addDoc(
    collection(db, "replies"),
    {
      reply,
      projectId,
      createdBy,
      attachments,
      createdAt: serverTimestamp(),
    }
  );
};